module.exports = __webpack_public_path__ + "static/media/signup-intro-img-fi.f6b3d499.png";